export const NOSIVO_TIME_ZONE = 'Asia/Kolkata';

export function greetingForHour(hour: number) {
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 17) return 'Good afternoon';
  if (hour >= 17 && hour < 21) return 'Good evening';
  return 'Good night';
}

export function hourInNosivoTimeZone(date = new Date()) {
  const hour = Number(new Intl.DateTimeFormat('en-GB', {
    timeZone: NOSIVO_TIME_ZONE,
    hour: '2-digit',
    hourCycle: 'h23',
  }).format(date));
  return hour === 24 ? 0 : hour;
}

export function nosivoGreeting(date = new Date()) {
  return greetingForHour(hourInNosivoTimeZone(date));
}
